export const infiniteScroll = (el, callback, stopLoading) => {
  const startLoadingPxFromBottom = 150
  if (el && el.scrollTop + el.clientHeight + startLoadingPxFromBottom >= el.scrollHeight) {
    if (!stopLoading) {
      callback()
    }
  }
}